import { render } from "./commentList.vue?vue&type=template&id=228d5b38&scoped=true"
import script from "./commentList.vue?vue&type=script&lang=js"
export * from "./commentList.vue?vue&type=script&lang=js"

import "./commentList.vue?vue&type=style&index=0&id=228d5b38&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-228d5b38"]])

export default __exports__